import {
  Button,
  Dialog,
  Field,
  Flex,
  HelpIcon,
  Input,
  Modal,
  Select,
  Spacer,
  Text,
} from '@oliasoft-open-source/react-ui-library';
import translations from 'client/internationalization/translation-map.json';
import { OwnerType } from 'common/enums/owner-enums';
import { IQuery } from 'common/interfaces/query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import { defaultConditionGroup, defaultQuery, QUERY_TEMPLATE_OWNER_TYPE_LABEL_MAP } from './query-utils';

interface IQueryCreateModalProps {
  companyId: string;
  onClose: () => void;
  onSubmit: (query: IQuery) => void;
}

export const QueryCreateModal = ({ companyId, onClose, onSubmit }: IQueryCreateModalProps) => {
  const { t } = useTranslation();
  const [queryName, setQueryName] = useState('');
  const [ownerType, setOwnerType] = useState<OwnerType>(OwnerType.USER);

  const typeOptions = [OwnerType.USER, OwnerType.CUSTOMER].map(value => ({
    label: t(QUERY_TEMPLATE_OWNER_TYPE_LABEL_MAP[value]),
    value,
  }));

  const handleSubmit = () => {
    onSubmit({
      ...defaultQuery({ companyId, queryName: queryName.trim() }),
      queryid: uuidv4(),
      ownerType,
      conditionGroups: [defaultConditionGroup],
    } as IQuery);
  };

  const content = (
    <>
      <Field>
        <Text bold>{t(translations.name)}</Text>
        <Spacer height="var(--padding-xxs)" />
        <Input value={queryName} onChange={(event) => setQueryName(event.target.value)} />
      </Field>
      <Field>
        <Flex alignItems="center" gap="var(--padding-xs)">
          <Text bold>{t(translations.query_access)}</Text>
          <HelpIcon
            maxWidth={350}
            text={(
              <>
                <div>{t(translations.query_accessUserHelp)}</div>
                <Spacer height="var(--padding-xs)" />
                <div>{t(translations.query_accessCompanyHelp)}</div>
              </>
            )}
          />
        </Flex>
        <Spacer height="var(--padding-xxs)" />
        <Select
          value={typeOptions.find(option => option.value === ownerType)}
          options={typeOptions}
          onChange={(event) => setOwnerType(event.target.value as OwnerType)}
        />
      </Field>
    </>
  );

  return (
    <Modal visible centered onEscape={onClose}>
      <Dialog
        dialog={{
          scroll: true,
          heading: t(translations.query_createQuery),
          content,
          footer: (
            <>
              <Button label={t(translations.save)} onClick={handleSubmit} disabled={!queryName.trim()} />
              <Button label={t(translations.cancel)} onClick={onClose} />
            </>
          ),
          onClose,
          width: '30%',
        }}
      />
    </Modal>
  );
};
